"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconRowHouse = function IconRowHouse(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M35 6.479v6.829l-1 .399v1.048l10.059-4.01q.558.843 1.046 1.735L34 16.907v1.957l11.916-4.759q.411.91.747 1.856L34 21.017V43h-2V14.505l-16 6.383V43h-2V14.505L.295 19.977q.203-1.203.522-2.362L15 11.952v-1.847L1.509 15.493q.512-1.354 1.178-2.624L17 7.154v6.154l-1 .399v.981zm-2 5.473V9.52l-17 7.346v1.868zM24 22h-4v6h4zm-1 1v4h-2v-4zm4 10v10h-1v-9h-4v9h-1V33zm14-11h-4v6h4zm-1 1v4h-2v-4zM7 22h4v6H7zm3 5v-4H8v4zm-1 6v9.787a24 24 0 0 1-1-.845V34H4v3.343a24 24 0 0 1-1-1.633V33zm30 9.787q.512-.409 1-.844V34h4v3.343q.532-.795 1-1.633V33h-6z",
    clipRule: "evenodd"
  })));
};

export { IconRowHouse, IconRowHouse as default };
